import { GET_DOCUMENT_SIGNED_URL } from "@/core/graphql/document";
import {
  IDocumentSignedURLRepository,
  IDocumentSignedURLRepositoryResponse,
} from "@/core/repositories/document";
import { ApolloClient } from "@apollo/client";

interface IDocumentSignedURLQueryResponse {
  deductionDocumentSignedURL: {
    signedUrl: string;
  };
}

export class DocumentSignedURLRepository implements IDocumentSignedURLRepository {
  constructor(private readonly client: ApolloClient) {}

  async getDocumentSignedURL(
    file_path: string,
    file_type: string,
    downloadable_file_name?: string
  ): Promise<IDocumentSignedURLRepositoryResponse> {
    const { data, error } = await this.client.query<IDocumentSignedURLQueryResponse>({
      query: GET_DOCUMENT_SIGNED_URL,
      variables: { params: { file_path, file_type, downloadable_file_name } },
      fetchPolicy: "no-cache",
    });

    if (!data || error) {
      throw new Error("Failed to get signed URL for document");
    }

    return {
      signedUrl: data.deductionDocumentSignedURL.signedUrl,
    };
  }
}
